export default function encodeHTML(str: string): string {
  return String(str).replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export function decodeHTML(str: string): string {
  return String(str).replace(/&lt;/g, '<').replace(/&gt;/g, '>');
}
